<template>
    <div class="instant-golfs-container">
        <p class="instant-golf-title">Golf Rounds</p>
        <div class="instant-golfs">
            <div v-for="(golf, index) in golfs" :key="index" class="instant-round">
                <div class="round-image">
                    <img :src="golf.ImageURL" :alt="golf.GolfCourseName"/>
                </div>
                <div class="golf-title">
                    <p class="round-image-title">{{ golf.Name }}</p>
                </div>
                <div class="instant-info">
                    <p class="instant-date display-opacity">
                        <span class="instant-icon">Unlimited</span>
                        <span class="instant-value">{{golf.Unlimited == false ? "No" : "Yes" }}</span>
                    </p>
                    <p class="golf-schedule-header">
                        {{ formatDate(golf.UnlimitedDateSpan.Start) }}
                        -
                        {{ formatDate(golf.UnlimitedDateSpan.End) }}
                    </p>
                    <table class="golf-schedule">
                        <thead>
                        <tr>
                            <th colspan="1">Time</th>
                            <th colspan="1">Mon</th>
                            <th colspan="1">Tues</th>
                            <th colspan="1">Wed</th>
                            <th colspan="1">Thur</th>
                            <th colspan="1">Fri</th>
                            <th colspan="1">Sat</th>
                            <th colspan="1">Sun</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(timeBreak, index) in golf.UnlimitedDateSpan.TimeBreaks" :key="index">
                            <td class="special-date">
                                <p>{{ formatTime(timeBreak.From) }}
                                </p>
                                <p>to</p>
                                <p>{{ formatTime(timeBreak.To) }}
                                </p>
                            </td>
                            <td class="special-td">{{ checkApplicable(timeBreak.DaysOfWeeksApplicable, 1) }}</td>
                            <td class="special-td">{{ checkApplicable(timeBreak.DaysOfWeeksApplicable, 2) }}</td>
                            <td class="special-td">{{ checkApplicable(timeBreak.DaysOfWeeksApplicable, 3) }}</td>
                            <td class="special-td">{{ checkApplicable(timeBreak.DaysOfWeeksApplicable, 4) }}</td>
                            <td class="special-td">{{ checkApplicable(timeBreak.DaysOfWeeksApplicable, 5) }}</td>
                            <td class="special-td">{{ checkApplicable(timeBreak.DaysOfWeeksApplicable, 6) }}</td>
                            <td class="special-td">{{ checkApplicable(timeBreak.DaysOfWeeksApplicable, 0) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="instant-more">
                    <a :href="golf.LinkURL" target="_blank" class="more-info"
                    >More Info and photos</a
                    >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import axios from "axios";

export default {
    name: "InstantGolfRounds",
    filters: {
        formatDate(value) {
            return moment.utc(String(value)).format("hh:mm A");
        },
        playDate(value) {
            return moment.utc(String(value)).format("MM/DD/YY");
        },
    },
    data() {
        return {};
    },
    computed: {
        golfs() {
            return this.$store.state.instantQuote.golfItems;
        },
        golfTime() {
            return this.$store.state.instantQuote.golfTime;
        },
        quoteId() {
            return this.$store.state.instantQuote.QuoteID;
        },
    },
    methods: {
        formatDate(date) {
            return moment(date).format("MMMM D YYYY");
        },
        formatTime(date) {
            return moment(date).format("h:mm A");
        },
        checkApplicable(applicableDays, day) {
            if (applicableDays instanceof Array &&
                applicableDays.includes(day)) {
                return "U";
            }
            return "";
        },
        customName({Description}) {
            return Description;
        },
        changeTeetime(option, GolfID) {
            let quoteId = this.quoteId;
            let timeId = option.TimeID;
            let golfId = GolfID;
            let pack = {
                golfId: GolfID,
                timeId: option.TimeID,
            };
            this.$store.commit("instantQuote/OVERRIDE_PACKAGE_VALUE", pack);
            axios
                .get(
                    `https://devscripts.execdigi.com/meridian/v2/index.php?action=update_selected_tee_time&QuoteID=${quoteId}&GolfID=${golfId}&SelectedTimeID=${timeId}`
                )
                .then(() => {
                })
                .catch((err) => {
                    console.log(err);
                });
            window.history.pushState(
                {
                    id: this.quoteId,
                },
                "Title",
                `/quoteId/${this.quoteId}`
            );
        },
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.display-opacity {
    opacity: 0.7;
}

.instant-golfs-container {
    padding: 30px 40px 0;
    border-bottom: 2px solid #5e4896;
    @media screen and (max-width: 500px) {
        padding: 0;
    }

    .instant-golf-title {
        text-align: left !important;
        color: #5e4896;
        font-family: Roboto;
        font-size: 24px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 18px;
        margin-left: 25px;
        margin-bottom: 30px;
        margin-top: 0;
    }

    .instant-golfs {
        display: flex;
        flex-wrap: wrap;

        .instant-round {
            margin-right: 20px;
            width: calc(25% - 20px);
            @media screen and (max-width: 1350px) {
                width: calc(33% - 20px);
            }
            @media screen and (max-width: 1050px) {
                width: calc(50% - 20px);
            }
            @media screen and (max-width: 660px) {
                width: 100%;
            }
            @media screen and (max-width: 660px) {
                width: 115%;
            }
            @media screen and (max-width: 500px) {
                margin-right: 0;
            }
            margin-bottom: 30px;

            .changedProperty {
                display: flex;
                align-items: center;
                align-content: center;
                justify-content: center;
                padding: 20px !important;

                .changedProperty-no-content {
                    height: 142px;
                }

                .changedProperty-content {
                    align-items: center;
                    align-content: center;
                    justify-content: center;

                    .tee-time-diferent {
                        font-size: 20px;
                        color: #5e4896;
                        font-weight: bold;
                    }

                    .timeOfDifferent {
                        color: #5e4896;
                        margin-left: 15px;
                        font-size: 18px;
                        @media screen and (max-width: 768px) {
                            font-size: 15px;
                        }
                        @media screen and (max-width: 660px) {
                            font-size: 18px;
                        }
                    }

                    .saveOfDifferent {
                        color: #5e4896;
                        margin-left: 15px;
                        font-size: 18px;
                        @media screen and (max-width: 768px) {
                            font-size: 13px;
                        }
                        @media screen and (max-width: 660px) {
                            font-size: 18px;
                        }
                    }
                }
            }

            .round-image {
                position: relative;
                width: 100%;
                height: 290px;

                img {
                    border-top-left-radius: 10px;
                    border-top-right-radius: 10px;
                    object-fit: cover;
                    width: 100%;
                    height: 100%;
                }

                .round-image-title {
                    position: relative;
                    bottom: 0;
                    height: 54px;
                    width: 100%;
                    opacity: 0.75;
                    background-color: #ff9600;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0;
                    color: #fefeff;
                    font-family: Roboto;
                    font-size: 25px;
                    font-weight: 500;
                    letter-spacing: 0;
                    line-height: 25px;
                    @media screen and (max-width: 768px) {
                        font-size: 20px;
                    }
                }
            }
        }

        .golf-title {
            height: 55px;
            background: #fff;
            display: flex;
            flex-wrap: wrap;
            padding: 0px;
            text-align: center;

            .round-image-title {
                padding: 0;
                bottom: 0;
                height: 54px;
                width: 100%;
                opacity: 0.75;
                background-color: #5e4896;
                display: flex;
                align-items: center;
                justify-content: center;
                margin: 0;
                color: #fefeff;
                font-family: Roboto;
                font-size: 25px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 25px;
            }
        }

        .instant-info {
            background: #fff;
            border: 1px solid #cccccc;
            border-top: 0px;
            align-items: center;
            max-height: 350px;
            min-height: 350px;
            @media screen and (max-width: 450px) {
                padding: 10px;
            }
            @media screen and (max-width: 330px) {
                height: 450px;
            }

            .instant-date {
                display: flex;
                align-items: center;
                width: 100%;
                margin-top: 0;
                margin-bottom: 40px;
                margin-right: 20px;
                padding-top: 10px;
                color: #5e4896;
                font-family: Roboto;
                font-size: 18px;
                letter-spacing: 0;
                line-height: 17px;
                user-select: none;
                cursor: not-allowed;
                @media screen and (max-width: 768px) {
                    font-size: 15px;
                }
                @media screen and (max-width: 450px) {
                    width: 100%;
                    text-align: center;
                    margin-right: 0;
                }

                .instant-icon {
                    margin-right: 15px;
                    white-space: nowrap;
                    font-size: 16px;
                    width: 120px;
                    padding-left: 5px;
                }

                .instant-value {
                    width: 100%;
                    padding: 10px;
                    border: 1px solid #ccc;
                    border-radius: 5px;
                    text-align: left !important;
                    margin-right: 10px;
                }
            }

            .golf-schedule-header {
                margin: 0;
                text-align: center;
                padding-bottom: 5px;
                color: black;
                font-family: "Roboto", sans-serif;
                font-size: 16px;
            }

            .golf-schedule {
                border-collapse: collapse;
                font-size: small;
                width: 100%;
                display: block;
                max-height: 240px;
                overflow: auto;

                p, th, td {
                    font-family: "Roboto", sans-serif;
                    font-size: 12px;
                    color: black;
                }

                th, td {
                    background-color: #e8e8e8;
                    padding: 0.2rem;
                    text-align: center;
                }

                th {
                    font-weight: normal;
                    padding: 1rem 0;
                }

                td {
                    border: 1px solid #999;

                    p{
                        display: block;
                        margin-block-start: 1em;
                        margin-block-end: 1em;
                        margin-inline-start: 0;
                        margin-inline-end: 0;
                    }
                }

                thead tr {
                    border: 1px solid #999;
                }

                .special-td {
                    padding: 0 15px;

                    @media screen and (max-width: 1100px) {
                        padding: 0px 13px;
                    }
                    @media screen and (max-width: 1050px) {
                        padding: unset;
                        width: 6%;
                    }
                }

                .special-date {
                    width: 22%;
                }
            }
        }

        .instant-more {
            height: 55px;
            background: #f0e9ff;
            display: flex;
            flex-wrap: wrap;
            padding: 0 20px;
            border: 1px solid #cccccc;
            border-top: 0;
            align-items: center;
            justify-content: flex-end;
            @media screen and (max-width: 450px) {
                padding: 5px 0 5px;
            }

            .instant-icon {
                margin-right: 9px;
            }

            .instant-photos {
                margin-top: 0;
                margin-bottom: 0;
                margin-right: 30px;
                color: #5e4896;
                font-family: Roboto;
                font-size: 18px;
                letter-spacing: 0;
                line-height: 17px;
                @media screen and (max-width: 768px) {
                    font-size: 15px;
                }
                @media screen and (max-width: 450px) {
                    width: 100%;
                    text-align: center;
                    margin: 0;
                }
            }

            .more-info {
                text-align: center !important;
                height: 33px !important;
                width: 188px !important;
                background-color: #ff9600 !important;
                color: #ffffff !important;
                font-family: Roboto !important;
                font-size: 15px !important;
                font-weight: 500 !important;
                letter-spacing: 0 !important;
                line-height: 35px !important;
                border: none !important;
                border-radius: 10px !important;
                @media screen and (max-width: 450px) {
                    margin: auto;
                }
            }
        }
    }
}
</style>
